var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendDownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 15.25C16.3102 15.25 16.1202 15.18 15.9702 15.03L12.4202 11.48L11.3302 13.12C11.2102 13.31 11.0002 13.43 10.7802 13.45C10.5502 13.47 10.3302 13.39 10.1802 13.23L6.9802 10.03C6.6902 9.74 6.6902 9.26 6.9802 8.97C7.2702 8.68 7.7502 8.68 8.0402 8.97L10.5902 11.52L11.6802 9.88C11.8002 9.7 12.0002 9.58 12.2302 9.55C12.4602 9.53 12.6802 9.61 12.8302 9.77L17.0302 13.97C17.3202 14.26 17.3202 14.74 17.0302 15.03C16.8802 15.18 16.6902 15.25 16.5002 15.25Z",
    fill: "#C90000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.25H14.5C14.09 15.25 13.75 14.91 13.75 14.5C13.75 14.09 14.09 13.75 14.5 13.75H15.75V12.5C15.75 12.09 16.09 11.75 16.5 11.75C16.91 11.75 17.25 12.09 17.25 12.5V14.5C17.25 14.91 16.91 15.25 16.5 15.25Z",
    fill: "#C90000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#C90000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDownRed);
export default __webpack_public_path__ + "static/media/TrendDownRed.746b08d1.svg";
export { ForwardRef as ReactComponent };